/**
 * Resource danh mục thôn xóm
 * ndhieu3 20.04.2023
 */
export default {
  Hamlet: {},
  HamletDetail: {
    HamletCode: 'Mã thôn xóm *',
    HamletName: 'Tên thôn xóm *',
  },
};
